export default __webpack_public_path__ + "static/media/icon_tanzanite.c668986b.png";